module.exports = __webpack_public_path__ + "assets/images/map-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/map-on.png
// module id = 1515
// module chunks = 1